import {Filtro} from './filtro';
import {RotaVo} from '../../vo/rota-vo';

export class FiltroIdentificador implements Filtro<RotaVo> {

  private comparadores: string[];

  constructor(
    comparadores: string[]
  ) {
    this.comparadores = comparadores;
  }

  filtrar(array: RotaVo[]): RotaVo[] {
    let resultado: RotaVo[] = [];

    this.comparadores.forEach((comparador) => {
      resultado = resultado.concat(
        array.filter(obj => obj.identificador.toLowerCase().includes(comparador.toLowerCase()))
      );
    });

    return resultado;
  }

  getFiltroNome(): string {
    return 'identificador';
  }

  getComparador(comparador: string): string {
    return this.comparadores.find((obj) => obj === comparador) || '';
  }

  getComparadores(): string[] {
    return this.comparadores;
  }

  addComparador(comparador: string): void {
    this.comparadores = this.comparadores.concat(comparador);
  }

  addComparadores(comparadores: string[]): void {
    this.comparadores = this.comparadores.concat(comparadores);
  }

  setComparadores(comparadores: string[]): void {
    this.comparadores = comparadores;
  }

}
